<app-search-costum>
  <ng-template let-item #body>
    <div class="flex flex-column gap-1">
      <div class="text-base text-color">{{item.uuid}}</div>
      <div class="text-base text-700 font-light"> {{item.nomeRegione}} - {{item.descrizionePunto}} - {{item.idPuntoCampionamento}}</div>
    </div>
  </ng-template>
</app-search-costum>
